import { render, staticRenderFns } from "./BusinessProcessEventsHistoryDispatcher.vue?vue&type=template&id=5a2ca974&"
import script from "./BusinessProcessEventsHistoryDispatcher.vue?vue&type=script&lang=js&"
export * from "./BusinessProcessEventsHistoryDispatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCardSection,QItem,QField,QTable,QTh,QTr,QTd,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QCardSection,QItem,QField,QTable,QTh,QTr,QTd,QBtn,QTooltip}, component.options.components || {})
